import React from 'react'

import classNames from 'classnames'

import { IconWrapper } from '../components'

export const IconFeather = ({
  size,
  color,
  className,
  ...props
}: React.ComponentPropsWithoutRef<'svg'> & {
  size?: string | number
}) => (
  <IconWrapper {...props} className={classNames(className, "icon-centivo", "icon-centivo--feather")} iconColor={color} size={size} width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">

      <defs>
          <path d="M20.9471068,3.05122979 C23.6818987,5.78602168 23.6820798,10.2198829 20.9476502,12.9548998 L14.2081536,19.714395 C14.0205327,19.9025726 13.7657299,20.0083366 13.5,20.0083366 L5.414,20.008 L2.70710678,22.7154434 C2.34662282,23.0759273 1.77939176,23.1036569 1.38710056,22.798632 L1.29289322,22.7154434 C0.902368927,22.3249191 0.902368927,21.6917541 1.29289322,21.3012298 L1.29289322,21.3012298 L4,18.593 L4,10.5083366 C4,10.2431201 4.10535684,9.98876617 4.29289322,9.80122979 L11.0428932,3.05122979 C13.7778663,0.316256736 18.2121337,0.316256736 20.9471068,3.05122979 Z M15.078,16.008 L9.414,16.008 L7.414,18.008 L13.0849183,18.0083366 L15.078,16.008 Z M12.4571068,4.46544335 L6,10.9225501 L6,16.593 L15.2928932,7.30122979 C15.6533772,6.94074583 16.2206082,6.91301629 16.6128994,7.21804118 L16.7071068,7.30122979 C17.0976311,7.69175408 17.0976311,8.32491906 16.7071068,8.71544335 L16.7071068,8.71544335 L11.414,14.008 L17,14.0083366 C17.0231252,14.0083366 17.0460671,14.0091215 17.0688005,14.0106663 L19.5318464,11.5422781 C21.4868177,9.58730532 21.4868177,6.41936782 19.5328932,4.46544335 C17.5789687,2.51151888 14.4110313,2.51151888 12.4571068,4.46544335 Z" id="icon--centivo--feather"/>
      </defs>
      <g id="Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(-1654.000000, -523.000000)"/>
          <g id="Icon/feather">
              <mask id="mask-2" fill="white">
                  <use xlinkHref="#icon--centivo--feather"/>
              </mask>
              <use id="Shape" fill="currentColor" xlinkHref="#icon--centivo--feather"/>
          </g>
      </g>
  </IconWrapper>
)
